import {
    getApiBarberProfileQueryKey,
    getApiBarberShiftIdQueryKey,
    usePostApiBarberShiftPause,
} from '@barbershop/api/barber'
import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export const usePauseCurrentShift = () => {
    const queryClient = useQueryClient()

    const { mutateAsync: pauseCurrentShift, isPending } = usePostApiBarberShiftPause({
        mutation: {
            onSuccess: async (_, { data: { shift_id } }) => {
                await queryClient.invalidateQueries({
                    queryKey: getApiBarberProfileQueryKey(),
                })
                await queryClient.invalidateQueries({
                    queryKey: getApiBarberShiftIdQueryKey(shift_id),
                })
                toast.success('Смена успешно поставлена на паузу')
            },
            onError: () => {
                toast.error('Ошибка при постановке смены на паузу')
            },
        },
    })

    return {
        pauseCurrentShift,
        isPending,
    }
}
